import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { adminAuthApi, setAccessToken } from '@/api';
import type { AdminLoginRequest, AdminProfile } from '@/types/admin';

interface AuthState {
  profile: AdminProfile | null;
  authenticated: boolean;
  loading: boolean;
  login: (payload: AdminLoginRequest) => Promise<void>;
  logout: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export const useAdminAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      profile: null,
      authenticated: false,
      loading: false,

      async login(payload) {
        set({ loading: true });
        try {
          const result = await adminAuthApi.login(payload);
          setAccessToken(result.accessToken);
          set({ profile: result.profile, authenticated: true });
        } finally {
          set({ loading: false });
        }
      },

      async logout() {
        try {
          await adminAuthApi.logout();
        } catch {
          /* ignore */
        }
        setAccessToken(null);
        set({ profile: null, authenticated: false });
      },

      async refreshProfile() {
        const profile = await adminAuthApi.me();
        set({ profile, authenticated: true });
      },
    }),
    {
      name: 'up-card-admin-auth',
      partialize: (state) => ({
        profile: state.profile,
        authenticated: state.authenticated,
      }),
    },
  ),
);
